import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { PrimengModule } from 'app/shared/modules/primeng.module';
import { FuseCountdownModule } from '@fuse/components';
import { SharedModule } from 'app/shared/modules/shared.module';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { AttendanceComponent } from './attendance.component';
import { AttendanceRoutingModule } from './attendance-routing.module';


@NgModule({
  declarations: [
    AttendanceComponent
  ],
  imports: [
    CommonModule,
    AttendanceRoutingModule,
    TranslateModule,
    FuseSharedModule,
    HttpClientModule,
    FormsModule,
    PrimengModule,
    FuseCountdownModule,
    SharedModule,
    NgxMaterialTimepickerModule
  ]
})
export class AttendanceModule { }
